import * as Yup from 'yup';
import { getImg } from 'src/services/AssetApi';

export const formatHoursMinutes = (value) => {
  if (!value) return '';

  // Remove all non-digit characters
  const numStr = value.toString().replace(/[^0-9]/g, '');

  // Limit to 4 digits (hhmm)
  const sliced = numStr.slice(0, 3);

  // Split into hour and minute
  const hour = sliced.slice(0, 1);
  const minute = sliced.slice(1, 3);

  // Return formatted string
  if (minute) {
    return `${hour}:${minute}`;
  } else if (hour) {
    return hour;
  } else {
    return '';
  }
};

const getNextDayAtHour = (hour = 8, minute = 0) => {
  const now = new Date();
  // Clamp hours between 0 and 23
  const safeHour = Math.max(0, Math.min(23, parseInt(hour, 10) || 0));
  // Clamp minute between 0 and 59
  const safeMinute = Math.max(0, Math.min(59, parseInt(minute, 10) || 0));
  const nextDay = new Date(
    now.getFullYear(),
    now.getMonth(),
    now.getDate() + 1,
    safeHour,
    safeMinute,
    0,
    0
  );
  // return Math.floor(nextDay.getTime() / 1000); // in seconds
  return nextDay.getTime();// in milliseconds
};

export const validationSchema = (item) => {
  const isCreate = !item?.id;
  const isRequired = true; //isCreate || !item.asset;

  let schema = Yup.object();
  schema = schema.shape({
    plateField: Yup.object()
      .nullable()
      .when([], {
        is: () => isCreate,
        then: (schema) => schema.required('Vui lòng chọn Biển Số'),
        otherwise: (schema) => schema.nullable(),
      }),
  });

  schema = schema.shape({
    created: Yup.string()
      .nullable()
      .when([], {
        is: () => isCreate,
        then: (schema) => schema.required('Ngày tiếp nhiên liệu phải có'),
        otherwise: (schema) => schema.nullable(),
      }),
  });

  schema = schema.shape({
    quantity: Yup.number()
      .transform((value, originalValue) => {
        if (typeof originalValue === 'string') {
          return parseFloat(originalValue.replace(/,/g, ''));
        }
        return value;
      })
      .min(1, 'Số lượng phải lớn hơn 1')
      .when([], {
        is: () => isCreate,
        then: (schema) => schema.required('Vui lòng nhập Số Lượng'),
        otherwise: (schema) => schema.nullable(),
      }),
  });

  schema = schema.shape({
    pricingField: Yup.object()
      .nullable()
      .when([], {
        is: () => isCreate,
        then: (schema) => schema.required('Vui lòng chọn Đơn Giá'),
        otherwise: (schema) => schema.nullable(),
      }),
  });

  schema = schema.shape({
    partnerField: Yup.object()
      .nullable()
      .when([], {
        is: () => isCreate,
        then: (schema) => schema.required('Vui lòng chọn Đối Tác'),
        otherwise: (schema) => schema.nullable(),
      }),
  });

  schema = schema.shape({
    image: Yup.string().when([], {
      is: () => isRequired,
      then: (schema) => schema.required('Hình phiếu xăng yêu cầu phải có'),
      otherwise: (schema) => schema.nullable(),
    }),
  });
  
  return schema;
};

export const handleSubmitted = async (
  values,
  item,
  apiCreate,
  apiUpdate,
  apiDelete,
) => {
  console.log('VALUES === ', values);
  //values.quantity = removeCommas(values.quantity); // Unuse but keep for backup

  // Check note content change before send to server
  if (!values.id) {
    if(!values.cardField){
      values.cardField = item.currentCard;
    }
    await apiCreate(values);
  } else {
    if (values.isVerified) {
      await apiDelete(values);
    } else {
      // Remove name of defaultImg when image had changed
      // if(values.image){
      //   //delete values.defaultImg.name;
      //   if(values.defaultImg){
      //     values.removeId = values.defaultImg.id;
      //   }
      // }

      // Check note content before send to server
      await apiUpdate(values);
    }
  }
};

export const initialValues = (formik, item) => {
  if(!formik) return;

  let myId = 0;
  if (item != null && (Object.keys(item).length > 0 || item.constructor !== Object)) {
    myId = item.id;
  }

  if(0 < myId){
    formik.setFieldValue('id', myId);
    formik.setFieldValue('created', null);

    formik.setFieldValue('myCarId', item.car?.id || '');
    formik.setFieldValue('note', item.note || '');

    setDefaultImage(formik, item.asset);
  }else{
    formik.setFieldValue('beginAt', getNextDayAtHour());
    formik.setFieldValue('quantity', null);
  }
};

// Set default single image to formik
function setDefaultImage(formik, object){
  if (object) {
    // Create a copy of item.asset and override the name property
    const assetCopy = { ...object, name: getImg(object.name) };
    // Set Formik field
    formik.setFieldValue('defaultImg', assetCopy);   
    formik.setFieldValue('image', object.name);
  }
};